import { memo, PropsWithChildren } from 'react';

import { ScrollToTopOnMount } from 'utils/ScrollToTopOnMount';
import { GoogleAnalytics } from 'utils/GoogleAnalytics';

import { Header } from './Header';
import { Footer } from './Footer';
import { ContactForm } from './ContactForm';
import { CookieBanner } from './CookieBanner';

const LayoutBase = ({ children }: PropsWithChildren) => {
  return (
    <div className="layout">
      <h1 className="hidden">AI Live Sim</h1>
      <ScrollToTopOnMount />
      <GoogleAnalytics />
      <Header />
      {children}
      <ContactForm />
      <Footer />
      <CookieBanner />
    </div>
  );
};

export const Layout = memo(LayoutBase);
